export var PortalType;
(function (PortalType) {
    PortalType["CORPORATE"] = "Corporate";
    PortalType["CONSUMER"] = "Consumer";
})(PortalType || (PortalType = {}));
//# sourceMappingURL=interfaces.js.map